var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowUp = function SvgArrowUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.191807 8.95152L0.584883 9.34733C0.708591 9.47094 0.873178 9.53904 1.04908 9.53904C1.22489 9.53904 1.38967 9.47094 1.51338 9.34733L5.99732 4.86319L10.4864 9.3523C10.6099 9.47591 10.7747 9.54391 10.9505 9.54391C11.1263 9.54391 11.2912 9.47591 11.4148 9.3523L11.808 8.95893C12.064 8.70313 12.064 8.28644 11.808 8.03063L6.46317 2.66659C6.33966 2.54308 6.17507 2.45605 5.99771 2.45605H5.99566C5.81975 2.45605 5.65517 2.54318 5.53165 2.66659L0.191807 8.0161C0.0680981 8.13961 0.00019455 8.30917 0 8.48498C0 8.66088 0.0680981 8.8281 0.191807 8.95152Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow_up.e5eba31d.svg";
export { ForwardRef as ReactComponent };